const firstValue = (...values) => values.find(value => typeof value === 'string' && value.trim() !== '')?.trim() || ''

const parseSearch = search => {
  const rawSearch = (search || '').replace(/^\?/, '')
  const params = new URLSearchParams(rawSearch)
  const knownKeys = ['company', 'client', 'tenant', 'ref', 'referral', 'campaign', 'promo', 'discount', 'discountCode', 'bookingId']
  const legacyCompanyFromRaw = rawSearch
    .split(/[?&]/)
    .map(value => decodeURIComponent(value || '').trim())
    .find(value => value && !value.includes('=') && !knownKeys.includes(value)) || ''
  const legacyCompanyFromParams = Array.from(params.entries())
    .find(([key, value]) => key && value === '' && !knownKeys.includes(key))?.[0] || ''
  const legacyCompany = legacyCompanyFromRaw || legacyCompanyFromParams

  return {
    companyCode: firstValue(params.get('company'), params.get('client'), params.get('tenant'), legacyCompany),
    referralToken: firstValue(params.get('ref'), params.get('referral'), params.get('campaign')),
    discountCode: firstValue(params.get('promo'), params.get('discount'), params.get('discountCode')),
    bookingId: firstValue(params.get('bookingId')).split('?')[0]
  }
}

export const getWebBookerContext = (locationValue = window.location) => parseSearch(locationValue?.search)

export const sanitizeWebBookerMessage = data => {
  if (!data || data.type !== 'UKCB_WEBBOOKER_CONTEXT') return null

  return {
    companyCode: firstValue(data.company, data.companyCode),
    referralToken: firstValue(data.ref, data.referralToken),
    discountCode: firstValue(data.promo, data.discountCode)
  }
}

export const mergeWebBookerContext = (current, incoming) => ({
  companyCode: incoming?.companyCode || current?.companyCode || '',
  referralToken: incoming?.referralToken || current?.referralToken || '',
  discountCode: incoming?.discountCode || current?.discountCode || ''
})
